<template>



	<!-- Contents-->
	<div class="container">


		<div class="content" v-if="mode === '' || mode === 'list' ">
			<h2 class="tit_page">{{ titleCodeVO.codeName }}</h2>

			<!-- 탭 -->
			<div class="board_category swiper-container">
				<ul class="swiper-wrapper">
					<li class="active swiper-slide">
						<router-link tag="button" :to="'/app/education/course/' + $route.params.cateCode">교육과정</router-link>
					</li>
					<li class="swiper-slide">
						<router-link tag="button" :to="'/app/education/main/' + $route.params.cateCode">교육과목</router-link>
					</li>
				</ul>
			</div>

			<code-selector @selectCode="setCateCode" :code="$route.params.cateCode" field="cateCode" ></code-selector>

			<form @submit.prevent="doSearch">
				<div class="board_search">
					<div class="input_box">
						<input type="text" name="" class="inp" placeholder="내용을 입력해 주세요." v-model="params.searchText">
						<button type="button"><img src="/ssflex_cs1/assets/img/common/ico/ico_search.svg" alt="검색"></button>
					</div>
				</div>
			</form>

			<div class="board_sort">
				<div class="total_box">총 <b>{{ eduCount }}</b>건</div>

				<course-sorter @doSort="doSort"></course-sorter>
			</div>

			<course-list :course-list="courseList"></course-list>


			<div class="board_more" v-if="courseList.length < eduCount">
				<button type="button" class="btn_more" @click="doLoadMore"><img src="/ssflex_cs1/assets/img/common/ico/ico_down_w.svg" alt=""></button>
			</div>

		</div>

		<!-- content: 교과정 상세 -->
		<course-detail v-if="mode === 'detail' && cidx > 0"></course-detail>

	</div>


</template>

<script>
import CourseList from "@/cs1/components/educations/course/courseList";
import CourseDetail from "@/cs1/components/educations/course/courseDetail";
import $ from "jquery";
import Swiper from "../../../../public/ssflex_cs1/assets/js/swiper.min";
import CodeSelector from "@/cs1/components/selectors/codeSelector";
import CourseSorter from "@/cs1/components/educations/course/courseSorter";

export default {
	name: "appEduCourses",
	components: {CourseSorter, CodeSelector, CourseDetail, CourseList},
	props: {
		cateCode: String,
		cateName: String,
	},
	data() {

		/**
		 * mode : list, detail
		 * @type {string|string}
		 */
		var mode = this.webUtils.getParameter("mode")
		mode = (mode === '') ? "list" : mode;

		/**
		 * cidx
		 * @type {number|string|string}
		 */
		var cidx = this.webUtils.getParameterInt("cidx");
		cidx = ( cidx > 0 ) ? cidx : 0;

		var params = new this.pageUtils.Params();
		params.size = 8;

		/**
		 * cateCode : params 우선, query 후순위
		 */
		if ( !this.stringUtils.isEmpty( this.$route.params.cateCode ) ) {
			params.cateCode = this.$route.params.cateCode
		} else {
			params.cateCode = this.$route.query.cateCode
		}

		if ( this.stringUtils.isEmpty(params.cateCode) ) {
			params.cateCode = "2001"
		}

		return {
			mode,
			cidx,
			cateCodeVO: {},
			coAccountVO: {},
			titleCodeVO: {},

			params,

			courseList: [],
			eduCount: 0,
			rateCode: 0,
		}
	},
	created() {
		this.$eventBus.$on("goDetail", (_cidx) => {
			this.goDetail( _cidx );
		});

	},
	async mounted() {

		this.titleCodeVO = await this.getCodeOne( this.params.cateCode )

		this.getCourseList();

		$(".list-controls .tab").each(function () {
			var tabnav = new Swiper($(this), {
				slidesPerView: "auto",
				spaceBetween: 24,
				freeMode: true,
				breakpoints: {
					767: {
						spaceBetween: 16,
					},
				},
			});
		});
	},
	methods: {


		getCourseList () {
			this.coAccountVO = this.getSessionProc();

			var temp = this.params
			if ( !this.stringUtils.isEmpty( this.$route.query.cateCode ) ) {
				temp.cateCode = this.$route.query.cateCode;
			}

			this.$eventBus.$emit("startProgress", 1)
			this.axiosCaller.get( this, this.APIs.EDU_COURSE + "/", temp, (res) => {
				this.$eventBus.$emit("doneProgress", 1)

				const result = res.data
				if ( result.status === "ok" ) {

					console.log( result )
					// this.eduList.push(...result.list)
					this.courseList = result.list
					this.eduCount = result.count

				} else {
					console.log( result.msg )
				}

			})

		},


		doLoadMore() {

			this.params.page++;
			this.params.scrollTop = false;
			this.pageUtils.routerPush( this, this.params )

			this.getCourseList();
		},


		setCateCode( _cateCode ) {

			// 빈코드가 올 경우 기본 코드 전송
			if ( _cateCode == null || _cateCode === "" ) {
				_cateCode = this.cateCode
			}

			this.params.page = 0
			this.params.cateCode = _cateCode;
			this.params.searchText = "";

			this.pageUtils.routerPush( this, this.params )

			this.getCourseList();
		},


		doSearch(e) {

			e.preventDefault()

			this.params.page = 0
			//this.params.cateCode = "";

			this.pageUtils.routerPush( this, this.params )

			this.getCourseList();
		},



		doSort ( _sort ) {
			this.params.sort = _sort;
			this.pageUtils.routerPush( this, this.params )
			this.getCourseList();
		},



		goDetail(_cidx) {

			this.mode = "detail"
			this.cidx = _cidx
			var temp = {
				mode: this.mode,
				cidx: _cidx,
			}
			this.pageUtils.routerPush(this, temp);
			this.webUtils.scrollTo('.content');
		},

	},
}
</script>

<style scoped>

</style>
